module.exports = __webpack_public_path__ + "img/c08_buildingtechindrasprosperity_Normal_ua.1356a42e.webp";